import React from 'react';

import LinkifiedText from '../../../shared/LinkifiedText/LinkifiedText';
import Button from '../../buttons/Button/Button';
import './ProductCard.css';

const ProductCard = ({ title, desc, image, link, serviceLink, leftDesc }) => {
  return (
    <div
      className='product-card-container'
      style={{ backgroundImage: `url("${image}")` }}
    >
      <div id='product-title-container'>
        <h1 id='product-title'>{title}</h1>
      </div>
      <div id='product-desc-container'>
        <h1 id='product-title'>{title}</h1>
        <p id='product-desc'>
          <LinkifiedText>{desc}</LinkifiedText>
        </p>
        {leftDesc && (
          <p id='product-desc__left'>
            <LinkifiedText>{leftDesc}</LinkifiedText>
          </p>
        )}
        {link && <Button href={link}>Book Appointment</Button>}
      </div>

      <div id='product-learn-more-container'>
        <h1 id='product-learn-more'>Learn More</h1>
      </div>
      {serviceLink && (
        <div className='service__btn'>
          <Button href={serviceLink}>Book Appointment</Button>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
